<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Перейти к блоку с ID"
            label-for="next_action"
        >
            <b-form-input
                id="next_action"
                v-model="$parent.next_action"
                placeholder="Укажите ID блока"
            ></b-form-input>
        </b-form-group>
    </div>
</template>
